// extracted by mini-css-extract-plugin
module.exports = {"ItemGroup":"CarCard_ItemGroup__2C5dB","ItemGroupTitle":"CarCard_ItemGroupTitle__3WWVc"};